import React, {Component} from 'react';

import Tab from '../tab';
import Target from './target';
import Automate from './automate';
import Save from './save';

const tabContentComponents = {
    Target,
    Automate,
    Save
};

const tabData = [
    {
        header: 'Target',
        body: 'Activate brand ambassadors within verticals and across global markets',
        identifier: 'target-tab'
    },
    {
        header: 'Automate',
        body: 'Scale campaigns quickly, efficiently and profitably',
        identifier: 'automate-tab'
    },
    {
        header: 'Save',
        body: 'Increase engagement and decrease costs',
        identifier: 'save-tab'
    }
];

export default class TargetAutomateSave extends Component {
    constructor(){
        super();
        this.handleSelect = this.handleSelect.bind(this);
        this.displayTabs = this.displayTabs.bind(this);
        this.displayTabContent = this.displayTabContent.bind(this);
        this.state = {
            tabToRender: 'Target',
            selectedTab: 'target-tab'
        }
    }

    handleSelect(selected, componentName){
        this.setState({
            tabToRender: componentName,
            selectedTab: selected
        });
    }

    displayTabs(){
        const {selectedTab} = this.state;

        return tabData.map((tab, ind) => {
            const isActive = tab.identifier === selectedTab ? true : false;

            return <Tab
                    key={ind}
                    header={tab.header}
                    body={tab.body}
                    identifier={tab.identifier}
                    isActive={isActive}
                    selectTab={() => { return this.handleSelect(tab.identifier, tab.header) }} />
        });
    }

    displayTabContent(){
        const {tabToRender} = this.state;
        const {isMobile, pageWidth} = this.props;
        const Type = tabContentComponents[tabToRender];

        return <Type isMobile={isMobile} pageWidth={pageWidth} />
    }

    render(){
        const tabs = this.displayTabs();
        const tabContent = this.displayTabContent();

        return(
            <div className='gr-12 target-automate-save'>
                <div className='row target-automate-save-tabs'>
                    {tabs}
                </div>

                <div className='row'>
                    {tabContent}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/target_automate_save.js